'use client';

import * as React from 'react';
import { cn } from '../lib/shadcn';

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  action?: React.ReactNode;
}

export function EmptyState({
  title,
  description,
  icon: Icon,
  action,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex w-full min-h-[280px] flex-col items-center justify-center rounded-xl border border-dashed border-muted-foreground/20 bg-muted/30 dark:bg-transparent p-8 text-center animate-in fade-in-50 shadow-inner',
        className,
      )}
      {...props}
    >
      <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-muted">
        <Icon className="size-6 text-muted-foreground" />
      </div>

      <h3 className="mt-4 text-sm font-semibold tracking-tight">{title}</h3>
      <p className="mt-2 max-w-sm text-xs text-muted-foreground">{description}</p>

      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
